import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

//reactstrap
import { Container } from "reactstrap";

//redux
import { useDispatch, useSelector } from "react-redux";

//components
import { InterventionsMain } from "@components/elements/Interventions";
import { HeadingBox } from "@components/common";

//actions
import { loadAllCaseActions } from "@actions";

function ActionsPage (props) {
  let { id } = useParams();
  const dispatch = useDispatch();

  //call Api
  useEffect(() => {
    const fetchData = () => {
      const params = {
        Action: "Load",
        Target: "Actions",
      };
      dispatch(loadAllCaseActions(id, params));
    };
    fetchData();
  }, [dispatch, id]);

  //props
  const { caseDetails } = props && props;

  //titlePage
  const titlePage = caseDetails?.Title;

  //store
  const storeActions = useSelector(
    (state) => state?.listActionsForElement || {}
  );

  return (
    <div className="wrapper -eActionsPage">
      <section className="eActionsCt">
        <Container>
          <HeadingBox title={titlePage || ""} currentPage="Actions" />
          <InterventionsMain 
            dataStore={storeActions}
            categoryType={`Action`}
            paramsElements={`Actions`}
          />
        </Container>
      </section>
    </div>
  );
}

export default ActionsPage;